import { useEffect, useCallback } from "react";
import { useNavigate } from "react-router";

import { useAuth } from "../../auth";
import { useApi } from "../../api";
import {
  useAppDispatch,
  useAppSelector,
  validatePanelVersion,
  resetStorage,
  fetchUsers,
  fetchPages,
  resetPages,
  resetSites,
} from "../../store";
import { isGlobalRole } from "../../helpers/permissions/featurePermission";

export const useInitialize = () => {
  const dispatch = useAppDispatch();
  const { user } = useAuth();
  const { getApi } = useApi();
  const navigate = useNavigate();

  const needToResetStorage = useAppSelector(
    (state) => state.panel.needToResetStorage,
  );
  const { pages, errorMessage: pagesErrorMessage } = useAppSelector(
    (state) => state.pages,
  );

  const updateUsers = useCallback(async () => {
    if (!pages || !user) return;
    const api = await getApi();
    dispatch(fetchUsers(api));
  }, [getApi, dispatch]);

  const updatePages = useCallback(async () => {
    if (!user) return;
    const api = await getApi();
    await dispatch(fetchPages(api));
  }, [user]);

  useEffect(() => {
    dispatch(resetPages());
    dispatch(resetSites());
  }, []);

  useEffect(() => {
    if (!pagesErrorMessage?.includes("403")) return;

    navigate("../auth/noCompany");
  }, [pagesErrorMessage]);

  useEffect(() => {
    if (isGlobalRole(pages)) updateUsers();
  }, [pages]);

  useEffect(() => {
    if (!user) return;

    const redirection = async () => {
      updatePages();
      dispatch(validatePanelVersion());
    };
    redirection();
  }, [user]);

  useEffect(() => {
    if (!needToResetStorage) return;
    dispatch(resetStorage());
    dispatch(validatePanelVersion());
  }, [needToResetStorage]);
};
